export default {"src":"/_next/static/image/public/images/ic_location_green.f1027d39044c5e7a7c0b1b91c3026619.svg","height":32,"width":32};